import { useContext } from "react";

import { IDynamicFormItemProps } from ".";

import USPhoneNumberInput from "components/PhoneNumberInput/USPhoneNumberInput";
import { TextAreaInput } from "components/TextAreaInput";
import TextInput from "components/TextInput/TextInput";

import c from "classnames";

import { DynamicFormContext } from "../DynamicFormContext";

export function TextInputItem({ item }: IDynamicFormItemProps<"inputText">) {
  const { form } = useContext(DynamicFormContext);

  const { content, key } = item;
  const { characterMax, disabled, element, format, hint } = content;
  const { label, required, value } = form.getFormInput(key);

  const classes = c("dynamic-form-item form-item--input-text");

  const textInputProps = {
    id: key,
    value: value as string,
    className: classes,
    dataTestId: key,
    disabled: disabled,
    error: form.getInputError(key),
    errorMessage: form.getInputErrorMessage(key),
    onBlur: form.onBlur,
    onChange: form.onChange,
  };

  if (format === "multiLine") {
    const textCharacterLimit = characterMax ? { character: { max: characterMax } } : {};

    return (
      <TextAreaInput
        {...textInputProps}
        limit={textCharacterLimit}
        placeholder={hint}
        required={required}
      />
    );
  } else if (element && (element === "phone_number" || element === "phone-number")) {
    return <USPhoneNumberInput {...textInputProps} label={label} />;
  } else {
    return (
      <TextInput
        {...textInputProps}
        label={label}
        maxCharacterLength={characterMax || undefined}
        required={required}
      />
    );
  }
}
